import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { FilterListComponent } from './filter-list.component';
import { BaseComponent } from '../bases/base-component';
export class PlantingSitesShellComponent extends BaseComponent {
    constructor(router, route, userService) {
        super();
        this.router = router;
        this.route = route;
        this.userService = userService;
        this.sortDirections = [{
                value: 'new',
                description: 'Newest to oldest'
            }, {
                value: 'old',
                description: 'Oldest to newest'
            }];
        this.backendCall = false;
        this.plantingSitesChange = new EventEmitter(true);
        this.onUpdatePageSize = new EventEmitter();
        this.showAddNew = false;
        this.unfilteredSitesChanged$ = new Observable();
        this.sortByMissingDirections = [{
                value: 'all',
                description: 'Show all sites'
            }, {
                value: 'complete',
                description: 'Complete sites'
            },
            {
                value: 'incomplete',
                description: 'Incomplete sites'
            }];
    }
    getSortDescription(isNewest) {
        const sort = this.sortDirections.find((item) => item.value === isNewest);
        return sort.description;
    }
    ngOnInit() {
        if (this.backendCall)
            this.getCurrentUser();
        const getSortType = this.route.snapshot.queryParamMap.get('sortType');
        this.sortMissingType = getSortType || "all";
        let search$ = this.route.queryParamMap
            .pipe(map(map => map.get('search')), distinctUntilChanged(), tap(searchText => this.searchText = searchText));
        let sortText$ = this.route.queryParamMap
            .pipe(map(map => map.get('sort')), distinctUntilChanged(), tap(sortText => this.sortText = sortText ? sortText : 'new'));
        let sortType$ = this.route.queryParamMap
            .pipe(map(map => map.get('sortType')), distinctUntilChanged(), tap(sortType => this.sortType = sortType));
        let filter$ = this.filterComponent.filterChange.asObservable();
        combineLatest([sortText$, search$, sortType$, filter$])
            .pipe(debounceTime(0), map(([sortText, searchText, sortType, filter]) => {
            return this.unfilteredSites
                .filter(value => filter(value) && this.quickSearch(value, searchText))
                .filter(value => filter(value) && this.filterMissing(value, sortType))
                .sort((siteA, siteB) => this.sortSites(siteA, siteB, sortText));
        }))
            .subscribe(this.plantingSitesChange);
        this.totalPlantedTrees = this.unfilteredSites.reduce((prev, next) => {
            return prev + next.totalTrees;
        }, 0);
        this.unfilteredSitesChanged$.subscribe((sites) => {
            this.unfilteredSites = sites;
            this.filterComponent.filterUpdated();
        });
    }
    searchChanged() {
        let _a = this.route.snapshot.queryParams, { search } = _a, params = tslib_1.__rest(_a, ["search"]);
        if (this.searchText) {
            params.search = this.searchText;
        }
        this.router.navigate([], {
            relativeTo: this.route,
            replaceUrl: true,
            queryParams: params,
        });
    }
    quickSearch(site, searchText) {
        if (!searchText)
            return true;
        let lowerSearchText = searchText.toLowerCase();
        if (site.title && site.title.toLowerCase().includes(lowerSearchText))
            return true;
        if (site.code && site.code.toLowerCase().includes(lowerSearchText))
            return true;
        return false;
    }
    updatePageSize() {
        this.onUpdatePageSize.emit(this.pageSize);
    }
    sortSites(siteA, siteB, sortText) {
        const sortNew = !sortText || sortText === 'new';
        const plantingDateTimeA = siteA.plantingDate instanceof Date ? siteA.plantingDate : new Date(siteA.plantingDate);
        const plantingDateTimeB = siteB.plantingDate instanceof Date ? siteB.plantingDate : new Date(siteB.plantingDate);
        const plantingDateA = plantingDateTimeA.toDateString();
        const plantingDateB = plantingDateTimeB.toDateString();
        if (plantingDateA === plantingDateB) {
            const timeA = { hour: plantingDateTimeA.getHours(), minute: plantingDateTimeA.getMinutes(), second: plantingDateTimeA.getSeconds() };
            const timeB = { hour: plantingDateTimeB.getHours(), minute: plantingDateTimeB.getMinutes(), second: plantingDateTimeB.getSeconds() };
            if (timeA.hour !== timeB.hour)
                return this.compareSites(timeA.hour, timeB.hour, sortNew);
            if (timeA.minute !== timeB.minute)
                return this.compareSites(timeA.minute, timeB.minute, sortNew);
            if (timeA.second !== timeB.second)
                return this.compareSites(timeA.second, timeB.second, sortNew);
            return 0;
        }
        if (plantingDateTimeA.getTime() > plantingDateTimeB.getTime())
            return sortNew ? -1 : 1;
        if (plantingDateTimeA.getTime() < plantingDateTimeB.getTime())
            return sortNew ? 1 : -1;
        return 0;
    }
    navigateSortSites(sortType) {
        let _a = this.route.snapshot.queryParams, { sort } = _a, params = tslib_1.__rest(_a, ["sort"]);
        params.sort = sortType;
        this.router.navigate([], {
            relativeTo: this.route,
            replaceUrl: true,
            queryParams: params
        });
    }
    changeSortMissingSites() {
        let _a = this.route.snapshot.queryParams, { sortType } = _a, params = tslib_1.__rest(_a, ["sortType"]);
        params.sortType = this.sortMissingType;
        this.router.navigate([], {
            relativeTo: this.route,
            replaceUrl: true,
            queryParams: params
        });
    }
    compareSites(statementA, statementB, sortNew) {
        if (statementA < statementB)
            return sortNew ? -1 : 1;
        else if (statementA > statementB)
            return sortNew ? 1 : -1;
        else
            return 0;
    }
    getCurrentUser() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.userService.getCurrentUserAsync();
        });
    }
    filterMissing(site, sortType) {
        if (!sortType)
            return true;
        if (sortType == "all")
            return true;
        if (sortType == "complete" && this.isEmptyObject(site.missingData))
            return true;
        if (sortType == "incomplete" && !this.isEmptyObject(site.missingData))
            return true;
        return false;
    }
    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }
}
